"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _store = require('web/store');
var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);

var _types = require('./types');

/* Which sidebar section a path belongs to, if any. */
 const sectionOf = (pathname) => {
  if (pathname.startsWith(_routes2.default.INBOX.ROOT)) return _types.RouteName.inbox
  if (pathname.startsWith(_routes2.default.DIRECTORY.ROOT)) return _types.RouteName.directory
  if (pathname.startsWith(_routes2.default.BROADCAST.ROOT)) return _types.RouteName.broadcast
  if (pathname === _routes2.default.FORMS.ROOT || pathname.startsWith(`${_routes2.default.FORMS.ROOT}/`)) return _types.RouteName.forms
  if (pathname.startsWith(_routes2.default.SETTINGS.ROOT)) return _types.RouteName.settings
  if (pathname.startsWith(_routes2.default.VIDEO.ROOT)) return _types.RouteName.video
  if (pathname.startsWith(_routes2.default.SUPER)) return _types.RouteName.super
  return null
}; exports.sectionOf = sectionOf

/* Where each section was last left (path and query), for this signed-in user
 * only and this tab only: going back to a section picks up there, the chat or
 * patient you had open, instead of its root. */
let owner = null
let lastPaths = new Map()

const forUser = (userKey) => {
  if (userKey === owner) return
  owner = userKey
  lastPaths = new Map()
}

 const rememberLocation = (userKey, location) => {
  forUser(userKey)
  const section = exports.sectionOf.call(void 0, location.pathname)
  if (section) lastPaths.set(section, `${location.pathname}${location.search}`)
}; exports.rememberLocation = rememberLocation

/* Opens a section from the sidebar: where it was left, or its root when it's
 * the section on screen (a second click goes back to the top) or new. */
 const openSection = (
  userKey,
  section,
  activeSection,
  gotoRoot,
) => {
  forUser(userKey)
  const lastPath = section === activeSection ? null : lastPaths.get(section)
  if (lastPath) _store.history.push(lastPath)
  else gotoRoot()
}; exports.openSection = openSection
